import request from '@/utils/request'

// 渠道列表
export function getladderdiagramList(params = {}) {
  return request({
    url: `/stsChargeReport/index`,
    method: 'get',
    params
  })
}
// 生成获客地址
export function spCorpspCustomerAcquisition(data = {}) {
  return request({
    url: '/spWorkWechat/spCorp/spCustomerAcquisition',
    method: 'post',
    data
  })
}
// 上传商户号的证书/密钥文件（使用 FormData）
export function uploadcert(data) {
  return request({
    url: '/capital/merchant/uploadCert',
    method: 'post',
    data,
    // 标记为文件上传，请求拦截器会避免强制设置 application/json
    isUpload: true
  })
}
